import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const IconStat = ({ icon, text, figure, colour, textColour }) => {
    return (
        <Box
            sx={{
                backgroundColor: colour,
                color: textColour,
                borderRadius: 3,
                height: '100%'
            }}
        >
            <Stack
                spacing={2}
                sx={{
                    alignItems: 'center',
                    py: 2
                }}
            >
                <Box sx={{ pb: 1 }}>
                    {icon}
                </Box>
                <Typography
                    variant="h4"
                    sx={{
                        alignItems: 'center',
                        lineHeight: 0,
                        pb: 1
                    }}
                >
                    {figure}
                </Typography>
                <Typography
                    variant="subtitle1"
                    sx={{
                        alignItems: 'center',
                        lineHeight: 1
                    }}
                >
                    {text}
                </Typography>
            </Stack>
        </Box>
    );
};

export default IconStat;